import { render, staticRenderFns } from "./InsightsLookerViewer.vue?vue&type=template&id=45959ce1&scoped=true"
import script from "./InsightsLookerViewer.vue?vue&type=script&lang=js"
export * from "./InsightsLookerViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45959ce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45959ce1')) {
      api.createRecord('45959ce1', component.options)
    } else {
      api.reload('45959ce1', component.options)
    }
    module.hot.accept("./InsightsLookerViewer.vue?vue&type=template&id=45959ce1&scoped=true", function () {
      api.rerender('45959ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/InsightsLookerViewer.vue"
export default component.exports